import { render } from "./Scadenzari.vue?vue&type=template&id=c944f59c"
import script from "./Scadenzari.vue?vue&type=script&lang=js"
export * from "./Scadenzari.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__